import { jsx as _jsx } from "react/jsx-runtime";
import WithSpeed from './WithSpeed/WithSpeed';
import WithoutSpeed from './WithoutSpeed/WithoutSpeed';
const Header = ({ sendMoney, showSpeedColumn, inverseHeader, }) => {
    return showSpeedColumn ? (_jsx(WithSpeed, { sendMoney: sendMoney })) : (_jsx(WithoutSpeed, { sendMoney: sendMoney, inverseHeader: inverseHeader }));
};
export default Header;
